<template>
    <div class="resourceList">
        <div class="resourceItem flexLayout paddingV8 bottomBorderF5F5F5" v-for="resourceItem in dataList"
             :key="resourceItem.id" :data-id="resourceItem.id">
            <div style="width: 58px;">
                <img :src="'icon/datum_type/icon_excel.png'" width="36" height="36" alt="Excel 文件图标" v-if="resourceItem.fileType === 'xls'"/>
                <img :src="'icon/datum_type/icon_excel.png'" width="36" height="36" alt="Excel 文件图标" v-if="resourceItem.fileType === 'xlsx'"/>
                <img :src="'icon/datum_type/icon_jpg.png'" width="36" height="36" alt="JPG 文件图标" v-if="resourceItem.fileType === 'jpg'"/>
                <img :src="'icon/datum_type/icon_pdf.png'" width="36" height="36" alt="PDF 文件图标" v-if="resourceItem.fileType === 'pdf'"/>
                <img :src="'icon/datum_type/icon_png.png'" width="36" height="36" alt="PNG 文件图标" v-if="resourceItem.fileType === 'png'"/>
                <img :src="'icon/datum_type/icon_ppt.png'" width="36" height="36" alt="PPT 文件图标" v-if="resourceItem.fileType === 'ppt'"/>
                <img :src="'icon/datum_type/icon_pptx.png'" width="36" height="36" alt="PPTX 文件图标" v-if="resourceItem.fileType === 'pptx'"/>
                <img :src="'icon/datum_type/icon_word.png'" width="36" height="36" alt="WORD 文件图标" v-if="resourceItem.fileType === 'doc'"/>
                <img :src="'icon/datum_type/icon_word.png'" width="36" height="36" alt="WORD 文件图标" v-if="resourceItem.fileType === 'docx'"/>
                <img :src="'icon/datum_type/icon_package.png'" width="36" height="36" alt="压缩文件图标" v-if="resourceItem.fileType === 'zip'"/>
                <img :src="'icon/datum_type/icon_package.png'" width="36" height="36" alt="压缩文件图标" v-if="resourceItem.fileType === 'rar'"/>
                <img :src="'icon/datum_type/icon_package.png'" width="36" height="36" alt="压缩文件图标" v-if="resourceItem.fileType === '7z'"/>
            </div>
            <div class="flexItem">
                <div class="font14r lineHeight21r14">{{ resourceItem.title }}</div>
                <div class="font12r color999">{{ fileHelper.formatHumanReadableSize(resourceItem.size) }}</div>
            </div>
            <div class="flexLayout" style=" justify-content: center; align-items: center">
                <img :src="'icon/lock.png'" width="20" height="20" alt="锁图标"/>
            </div>
        </div>
    </div>
</template>

<script>
import generalCmpPart from '@/components/part/generalCmpPart';

// config
import appConfig    from '@/appConfig';

// util and api
import appHelper    from "@/util/appHelper";
import fileHelper   from "@/util/fileHelper";

const config = {
    apiConfig : {
        list : {
            url : 'portal/datum/dataList',
            dataPath : 'data.dataList',
            dataColumnMapping : {
                // userName : 'name''
            },
            params : {}
        }
    }
};

export default {
    name: "datumResourceList",
    extends : generalCmpPart,
    props : {
        id : String
    },
    data () {
        return {
            apiConfig : config.apiConfig,
            enableDataList : true,
            fileHelper
        }
    },
    methods : {
        onLoadDataList() {
            this.$emit('loaded', this.dataList);
        }
    },
    mounted() {
        this.apiConfig.list.params.datumId = this.id;
        this.loadDataList();
    }
}
</script>

<style lang="scss" scoped>

</style>
